import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Col as Col$1 } from 'react-bootstrap';
import { createResponsiveClasses } from '../utils/create-responsive-classes/create-responsive-classes.esm.js';

/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * Please use Bootstrap's official grid system instead.
 * See: https://getbootstrap.com/docs/5.3/layout/grid/
 */ const Col = /*#__PURE__*/ forwardRef(({ span, offset, spacingGroup, className, ...rest }, ref)=>{
    // Show deprecation warning in development
    if (process.env.NODE_ENV === 'development') {
        console.warn('⚠️  Col component is deprecated and will be removed in a future version.\n' + "Please use Bootstrap's official grid system instead.\n" + 'See: https://getbootstrap.com/docs/5.3/layout/grid/');
    }
    return jsx(Col$1, {
        ...rest,
        className: classNames(spacingGroup, className, createResponsiveClasses({
            bsPrefix: 'col',
            responsiveDefinitition: span
        }), createResponsiveClasses({
            bsPrefix: 'offset',
            responsiveDefinitition: offset
        })),
        ref: ref
    });
});

export { Col };
